// extracted by mini-css-extract-plugin
export default {"link":"link_link__GVEQh","clickable":"link_clickable__PuDmo","linkPrimary":"link_linkPrimary__oX8nv"};